'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdt';
var iconName = 'house';
var width = 576;
var height = 512;
var aliases = [127968,63498,63500,"home","home-alt","home-lg-alt"];
var unicode = 'f015';
var svgPathData = ['M80 204.8L80 496l128 0 0-184 0-8 8 0 144 0 8 0 0 8 0 184 128 0 0-291.2L288 26.5 80 204.8z', 'M288 5.5l5.2 4.5 280 240-10.4 12.1L512 218.5 512 504l0 8-8 0L72 512l-8 0 0-8 0-285.5L13.2 262.1 2.8 249.9l280-240L288 5.5zm0 21.1L80 204.8 80 496l128 0 0-184 0-8 8 0 144 0 8 0 0 8 0 184 128 0 0-291.2L288 26.5zM224 496l128 0 0-176-128 0 0 176z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faHouse = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;